function isObject(value) {
    return typeof value === "object" && value !== null;
}

export { isObject };
//# sourceMappingURL=is-object.mjs.map
